<template>
  <div class="tags-list">
    <div cy="tags-list"
         class="emoji flex">
          <span v-for="({icon, key, value}) in tagsList"
                :key="key">
            <i v-if="(tags[key] === value) || isEdit"
               @click="selectTag({key, value})"
               :class="{'active-tag': (tags[key] === value), pointer: isEdit, [key]: key}"
               v-html="icon" />
          </span>
    </div>
  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  import {computed, reactive} from "vue";
  import {icons} from "@/store/data";

  const props = defineProps({
    tags: {
      type: Object,
      default: {}
    },
    resultId: String,
    columnId: String,
  })

  const { state } = useStore()
  const isEdit = computed(() => state.dashboard.selectedColumn.state === 'edit-tags' && state.dashboard.selectedColumn.id === props.columnId)
  const tagsList = reactive([
    {icon: icons.positive, value: 'positive', key: 'sentiment'},
    {icon: icons.negative, value: 'negative', key: 'sentiment'},
    {icon: icons.neutral, value: 'neutral', key: 'sentiment'},
    {icon: icons.full_control, value: 'full_control', key: 'control'},
    {icon: icons.partial_control, value: 'partial_control', key: 'control'},
    {icon: icons.no_control, value: 'no_control', key: 'control'},
    {icon: icons.not_this_entity, value: 'not_this_entity', key: 'entity'},
  ])
  const emit = defineEmits(['select'])

  function selectTag ({key, value}) {
    if (isEdit.value) {
      emit('select', {key, value, resultId: props.resultId})
    }
  }
</script>

<style lang="scss">
  .tags-list {
    @media only screen and (min-width: 0) {
      i,
      svg path {
        height: 20px;
        width: 20px;
        display: block;
      }
      i {
        margin-right: 6px;
        opacity: 0.3;
        &.control svg path {
          fill: var(--tags-control-color);
        }
        &:hover {
          opacity: 1;
        }
      }
      .active-tag {
        opacity: 1;
      }
    }
  }
</style>